module.exports = __webpack_public_path__ + "fonts/Raleway-ExtraBold.c9503ab0.ttf";